import Vue from 'vue';

Vue.directive('opacity', {
  bind(el, binding) {
    const element = el;
    element.classList.add('v-opacity');
    element.style.opacity = binding.value ? 1 : 0;
  },
  update(el, binding) {
    const element = el;
    element.style.opacity = binding.value ? 1 : 0;
  },
});



// WEBPACK FOOTER //
// ./src/directives/Opacity.js